"use strict";

// .closest
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this;

    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
} 

// throttle
function throttle(delay, fn) {
  var last, deferTimer;
  return function() {
    var context = this, args = arguments, now = +new Date;
    if(last && now < last + delay)       {
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function() { last = now; fn.apply( context, args ); }, delay);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

function getTransitionDuration (element) {
  return parseFloat(window.getComputedStyle(element).getPropertyValue('transition-duration')) * 1000;
}

window.wbBackdrop = (function () {

  var backdrop = document.getElementById('wb-bckdrp19'),
      classBackdropHidden = 'wb-bckdrp19--hidden',
      classBackdropSidenav = 'wb-bckdrp19--sidenav',
      classBackdropSearch = 'wb-bckdrp19--search',
      classBackdropFlyout = 'wb-bckdrp19--flyout';

  function hide () {
    /*if(window.location.href.includes('/blogs/')){backdrop.classList.add(classBackdropHidden)}
    if(window.location.href.includes('/contact')){backdrop.classList.add(classBackdropHidden)}*/
    backdrop.classList.add(classBackdropHidden);
    backdrop.classList.remove(classBackdropSidenav);
    backdrop.classList.remove(classBackdropSearch);
    backdrop.classList.remove(classBackdropFlyout);
  }

  function show () {
    backdrop.classList.remove(classBackdropHidden);
  }

  function showForSidenav () {
    /*if(window.location.href.includes('/blogs/')){backdrop.classList.add(classBackdropSidena)}
    if(window.location.href.includes('/contact')){backdrop.classList.add(classBackdropSidena)}*/
    backdrop.classList.add(classBackdropSidenav);
    backdrop.classList.remove(classBackdropSearch);
    backdrop.classList.remove(classBackdropFlyout);
    show();
  }

  function showForSearch () {
    backdrop.classList.remove(classBackdropSidenav);
    backdrop.classList.add(classBackdropSearch);
    backdrop.classList.remove(classBackdropFlyout);
    show();
  }

  function showForFlyout () {
    backdrop.classList.remove(classBackdropSidenav);
    backdrop.classList.remove(classBackdropSearch);
    backdrop.classList.add(classBackdropFlyout);
    show();
  }

  return {
    hide: hide,
    show: show,
    showForSidenav: showForSidenav,
    showForSearch: showForSearch,
    showForFlyout: showForFlyout
  }

})();


// TODO: Measure scroll bar width and set it as padding on body?

window.wbMenu = (function (menu, before, after) {

  var classMenuMobileOpen = 'wb-header__sidenav--open',
      classHtmlMenuOpened = 'wb-menumobile--opened',
      classHtmlNoOverflow = 'wb-nooverflow';

  var html = document.documentElement,
      backdrop = document.getElementById('wb-bckdrp19');

  var pagecenter = document.getElementById('page-center');

  var isOpen = false;

  var duration = getTransitionDuration(pagecenter);
  var timer;

  function resetTimeout() {
    if (timer) {
      clearTimeout(timer);
    }
  }

  function showMenu () {
    isOpen = true;
    resetTimeout();
    menu.classList.add(classMenuMobileOpen);
    if (typeof before === 'function') {
      before.call(null, isOpen); 
    }
    html.classList.add(classHtmlNoOverflow);
    html.classList.add(classHtmlMenuOpened);
    window.wbBackdrop.showForSidenav();
    timer = setTimeout(function () {
      if (typeof after === 'function') {
        after.call(null, isOpen); 
      }
    }, duration);
  }

  function hideMenu () {
    isOpen = false;
    resetTimeout();
    if (typeof before === 'function') {
      before.call(null, isOpen); 
    }
    html.classList.remove(classHtmlMenuOpened);
    window.wbBackdrop.hide();
    timer = setTimeout(function () {
      html.classList.remove(classHtmlNoOverflow);
      menu.classList.remove(classMenuMobileOpen);
      if (typeof after === 'function') {
        after.call(null, isOpen); 
      }
    }, duration);
  }

  function toggleMenu () {
    isOpen = !isOpen;
    if (isOpen) {
      showMenu();
    } else {
      hideMenu();
    }
  }

  function onBackdropClicked (event) {
    event.preventDefault();
    isOpen = true;
    toggleMenu();
  }

  document.addEventListener('DOMContentLoaded', function (event) {
    if(backdrop != undefined){
      backdrop.addEventListener('click', onBackdropClicked);
    }
  });


  return {
    show: showMenu,
    hide: hideMenu,
    toggle: toggleMenu,
  };

});



window.wbHeader = (function () {

  var header = document.getElementById('wb-hdr19'),
      headerMain = document.querySelector('.wb-hdr19-main'),
      headerSidenav = document.getElementById('header-sidenav');

  //
  // MENU TOGGLE
  //
  var menuToggle = (function () {

    var banner = document.getElementById('wb-hdr19-banner');

    var classHeaderToggled = 'wb-hdr19-top__toggle--toggled',
        toggle;

    var pagecenter = document.getElementById('page-center'),
        classPagecenterOntop = 'page-center--ontop';
    var y;

    var onResize = throttle(150, function () {
      window.wbHeaderSidenav.hide();
    });

    function afterToggle (isOpen) {
      if (isOpen) {
        setTimeout(function () {
          window.addEventListener('resize', onResize, { capture: true, passive: true });
        }, 16);
      } else {
        window.removeEventListener('resize', onResize, { capture: true, passive: true });
        setTimeout(function () {
          pagecenter.classList.remove(classPagecenterOntop);
          sidenav.resetActivePanel();
        }, 0);
      }
    }

    function beforeToggle (isOpen) {
      if (isOpen) {
        y = window.scrollY || window.pageYOffset;
        var h = window.innerHeight;
        header.style.setProperty('top', y + 'px', 'important');
        pagecenter.classList.add(classPagecenterOntop);
        pagecenter.style.position = 'fixed';
        pagecenter.style.top = (-y) + 'px';
        pagecenter.style.height = (y + h) + 'px';
        toggle.classList.add(classHeaderToggled);
      } else {
        toggle.classList.remove(classHeaderToggled);
        pagecenter.style.position = '';
        pagecenter.style.height = '';
        pagecenter.style.top = '';
        header.style.top = '';
        window.scrollTo(0, y);
        setTimeout(function () {
          var restoredY = window.scrollY || window.pageYOffset;
          if (restoredY !== y) {
            window.scrollTo(0, y);
          }
        }, 0);
      }
    }

    window.wbHeaderSidenav = window.wbMenu(headerSidenav, beforeToggle, afterToggle);

    document.addEventListener('DOMContentLoaded', function () {
      toggle = document.getElementById('headertoggle');
      toggle.addEventListener('click', function (event) { 
        event.preventDefault();
        window.wbHeaderSidenav.toggle();
      });
    }, { passive: true });

  })();


  //
  // SEARCH
  //
  var search = (function () {


    /*
    //Search Tracking
    input.addEventListener('change', function () {
      //console.log($(this).val())
      fbq('track', 'Search', {contents: 'trigger:onchange',search_string: $(this).val()});

    });
    input.addEventListener("keyup", function(event) {
      // Number 13 is the "Enter" key on the keyboard
      if (event.keyCode === 13) {
        //console.log($(this).val())
        fbq('track', 'Search', {contents: 'trigger:enter',search_string: $(this).val()});
      }
    });
*/


  })();

  
  //
  // Default Nav Setting
  //
  var default_nav = (function () {
    
    var selectorFlyoutFashion = 'flyout-fashion';
    var selectorFlyoutFitness = 'flyout-fitness';
    var selectorClassLogo = '.wb-hidden-header-mobile';
    var cookieFashion = '#selected-fashion';
    var cookieFitness = '#selected-fitness';
    var cookieValueFashion = 'fashion';
    var cookieValueFitness = 'fitness';
    var host = window.location.host;
    var page = window.location.pathname;
    var hash = window.location.hash;
    var default_page_cookie = 'default-index-page-bf23';
    var categoryButtonSelector = '.wb-hdr19-main__left__link--small';
    var categoryButtonActiveClass = 'wb-hdr19-main__left__link--selected';

    var selectorMobileFashion = '.wb-header__sidenav__main__link--title-link--default-fashion';
    var selectorMobileFitness = '.wb-header__sidenav__main__link--title-link--default-fitness';

    var newDomain = domain;
    

    function checkCookieExist(cookie) {
      return typeof cookie !== 'undefined';
    }
    
    function getDefaultPageCookie () {
      var activeCookie = Cookies.get(default_page_cookie);
      return activeCookie;
    }

    function setButtonColor (category) {
      var btn = document.querySelector(categoryButtonSelector + '[data-category="'+category+'"]');
      if(btn != null) {
        btn.classList.add(categoryButtonActiveClass);
      }
      if(category == 'fashion') {
        var btnOther = document.querySelector(categoryButtonSelector + '[data-category="fitness"]');
      } else if(category == 'fitness') {
        var btnOther = document.querySelector(categoryButtonSelector + '[data-category="fashion"]');
      }
      if(btnOther != null) {
        if(btnOther.classList.contains(categoryButtonActiveClass)) {btnOther.classList.remove(categoryButtonActiveClass)}
      }
    }
    
    function setDefaultPageCookie (category) {
      
    if (newDomain === '.myshopify.com') {
        newDomain = window.location.hostname;
    }
     Cookies.set(default_page_cookie, category, {expires: 5, path: '/', domain: newDomain});
     //hideFlyoutMenu(category);
     redirectLogoLink(category);
     setButtonColor(category);
    }
    
      
    function redirectLogoLink(cat) {
      var logos = document.querySelectorAll('.wb-hdr19-top__logo');
      if(typeof cat !== 'undefined') {
        if(cat == cookieValueFashion || cat == cookieValueFitness ) {
          logos.forEach((logo) => {
            if(cat==cookieValueFashion) {
              logo.parentNode.setAttribute('href', '/pages/sportswear');  
            } else if (cat==cookieValueFitness) {
              logo.parentNode.setAttribute('href', '/pages/fitness');  
            }
          });
        }
      }
    }
  
    function hideFlyoutMenu (cat) {
      
      var flyoutFashion = document.getElementsByClassName('wb-hdr19-main__flyout--page-fashion');
      var flyoutFitness = document.getElementsByClassName('wb-hdr19-main__flyout--page-fitness');
      $(flyoutFashion).remove();
      $(flyoutFitness).remove();
    }

    function removeCookie () {
      if (newDomain === '.myshopify.com') {
          newDomain = window.location.hostname;
      }
      Cookies.remove(default_page_cookie, {expires: 7, path: '/', domain: newDomain});
    }

    function init() {
      if (window.GeoRedirect && GeoRedirect.isBot()) {
        return;
      }
      var categoryCookie = getDefaultPageCookie();
      var currentCategory = getDefaultPageCookie();
      var url = window.location.pathname;
      var $wbBody = $('.wb-body');
      if(hash == '#unselect') {
        removeCookie();
        return;
      }
      
      if(url.includes('/pages/') || url.includes('/collections/')) {
        if (url.includes('sportswear')) {
          setDefaultPageCookie('fashion');
          currentCategory = 'fashion';
        } else if (url.includes('fitness')) {
          setDefaultPageCookie('fitness');
          currentCategory = 'fitness';
        } else {
          if(typeof categoryCookie !== 'undefined') {
            setDefaultPageCookie(categoryCookie);
          }
        }
      } else if (url.includes('/products/')){
        if(header_product_tags == null) {console.log('products null');return;}
        if(header_product_tags.includes('product_line_fashion')) {
          setDefaultPageCookie('fashion');
          currentCategory = 'fashion';
        } else if (header_product_tags.includes('product_line_fitness')) {
          setDefaultPageCookie('fitness');
          currentCategory = 'fitness';
        } else {
          console.log('tag not found');
        }
      } else if (url == '/' && typeof categoryCookie !== 'undefined') {
        if(categoryCookie==cookieValueFashion){
          window.location.pathname = '/pages/sportswear';
        } else if (categoryCookie==cookieValueFitness) {
          window.location.pathname = '/pages/fitness';
        }
      } else {
        if(typeof categoryCookie !== 'undefined') {
          setDefaultPageCookie(categoryCookie);
        }
      }
      $wbBody.attr('is-category',currentCategory)
    }
    
    document.addEventListener('DOMContentLoaded', function () {
      init(); //Enable after Birthday Sale
      
    }, { passvie: true });

    return {
      setDefaultPageCookie: setDefaultPageCookie,
      getDefaultPageCookie: getDefaultPageCookie,
      removeCookie: removeCookie,
      init: init
    }
  })();
  
  //
  // SIDENAV
  //
  var sidenav = (function () {

    var selectorSidenavPanelLinks = '.wb-header__sidenav__main__link[href*="#"]',
        selectorSidenavPanel = '.wb-header__sidenav__main__panel',
        classSidenavLinkPrev = 'wb-header__sidenav__main__link--prev',
        classSidenavLinkNext = 'wb-header__sidenav__main__link--next',
        classSidenavPanelHidden = 'wb-header__sidenav__main__panel--hidden',
        classSidenavPanelOpened = 'wb-header__sidenav__main__panel--opened',
        classSidenavPanelSubopened = 'wb-header__sidenav__main__panel--subopened';

    var blockMainNav = "side-nav-main",
        blockWear = "side-nav-fashion",
        blockFitness = "side-nav-fitness",
        classBlockNavs = ".wb-header__sidenav__main__link--title-link",
        classBlockActive = 'wb-header__sidenav__main__panel__list--active',
        classBlockClose = 'wb-header__sidenav__main__panel__list--close',
        categoryTitle = ".wb-header__sidenav__main__link--title",
        classActiveLink = "wb-header__sidenav__main__link--title--active";
    var activeBlockNav = null;

    var toplink = document.getElementById('headersidenav-toplink');

    var duration;
    var timer;

    function resetTimeout() {
      if (timer) {
        clearTimeout(timer);
      }
    }
    
    function resetNav(active){
      var mainNavs = document.querySelectorAll('.wb-header__sidenav__main__panel__list--category');
      mainNavs.forEach((element) => {
        if(element.classList.contains(classBlockActive)) {element.classList.remove(classBlockActive)}
        if(!element.classList.contains(classBlockClose)) {element.classList.add(classBlockClose)}
      });
      var defaultNav = document.querySelector('#side-nav-main');
      defaultNav.classList.add(classBlockActive);
      defaultNav.classList.remove(classBlockClose);
      active.classList.remove(classActiveLink);
    }

    function initBlockNav() {
      var cat = wbHeader.default_nav.getDefaultPageCookie();
      if(typeof cat !== 'undefined') {
        var tthis = document.querySelector('[data-category="'+cat+'"]').parentElement;
        var current = document.querySelector('.'+classBlockActive);
        if(!current){return;}
        current.classList.remove(classBlockActive);
        current.classList.add(classBlockClose);
        var category = tthis.querySelector(categoryTitle).dataset.category;
        var newActive = document.querySelector('#side-nav-'+category);
        if(!newActive){return;}
        newActive.classList.add(classBlockActive);
        newActive.classList.remove(classBlockClose);
        var activeLink = document.querySelector('.'+classActiveLink);
        if(!activeLink) {
          tthis.classList.add(classActiveLink)
        } else {
          activeLink.classList.remove(classActiveLink);
          tthis.classList.add(classActiveLink);
        }
      } else {
      }
    }
    
    function updateBlockNav () {
      var default_cookie = wbHeader.default_nav.getDefaultPageCookie();
      wbHeader.default_nav.setDefaultPageCookie(this.children[0].dataset.category);
      
      var activeLink = document.querySelector('.'+classActiveLink);
      if(activeLink == this) {
        //resetNav(this);
        return;
      } 
      if(!activeLink) {
        this.classList.add(classActiveLink)
      } else {
        activeLink.classList.remove(classActiveLink);
        this.classList.add(classActiveLink);
      }
      var current = document.querySelector('.'+classBlockActive);
      if(!current){return;}
      current.classList.remove(classBlockActive);
      current.classList.add(classBlockClose);
      var category = this.querySelector(categoryTitle).dataset.category;
      var newActive = document.querySelector('#side-nav-'+category);
      if(!newActive){return;}
      newActive.classList.add(classBlockActive);
      newActive.classList.remove(classBlockClose);
    }
    

    function getCurrentPanel (link) {
      return link.closest(selectorSidenavPanel);
    }

    function getTargetPanel (link) {
      return document.getElementById(link.getAttribute('href').substr(1));
    }

    function showPrevPanel (panel, prevPanel) {
      resetTimeout();

      prevPanel.classList.remove(classSidenavPanelHidden);

      setTimeout(function () {
        panel.classList.remove(classSidenavPanelOpened);
        prevPanel.classList.remove(classSidenavPanelSubopened);
        prevPanel.classList.add(classSidenavPanelOpened);
      }, 16);  

      timer = setTimeout(function () {
        panel.scrollTop = 0;
        panel.classList.add(classSidenavPanelHidden);
      }, duration);
    }

    function showNextPanel (panel, nextPanel) {
      resetTimeout();

      nextPanel.classList.remove(classSidenavPanelHidden);

      setTimeout(function () {
        panel.classList.add(classSidenavPanelSubopened);
        nextPanel.classList.add(classSidenavPanelOpened);
      }, 16);

      timer = setTimeout(function () {
        panel.scrollTop = 0;
        panel.classList.add(classSidenavPanelHidden);
      }, duration);
    }

    function isPrevLink (link) {
      return link.classList.contains(classSidenavLinkPrev);
    }

    function isNextLink (link) {
      return link.classList.contains(classSidenavLinkNext);
    }

    function onLinkClicked (event) {
      event.preventDefault();
      if (isPrevLink(this)) {
        showPrevPanel(getCurrentPanel(this), getTargetPanel(this));
      } else if (isNextLink(this)) {
        showNextPanel(getCurrentPanel(this), getTargetPanel(this));
      }
    }


    document.addEventListener('DOMContentLoaded', function () {
      duration = getTransitionDuration(document.querySelector(selectorSidenavPanel));
      var links = document.querySelectorAll(selectorSidenavPanelLinks);
      Array.prototype.slice.call(links).forEach(function (link) {
        link.addEventListener('click', onLinkClicked);
      });
      
      initBlockNav();
      var blockNavs = document.querySelectorAll(classBlockNavs);
      Array.prototype.slice.call(blockNavs).forEach(function (blockNav) {  
        if(header_template == 'index') {
          console.log('index page');
        } else {
          blockNav.addEventListener('click', updateBlockNav);  
        }
        
      });
    }, { passvie: true });

    return {
      resetActivePanel: function () {
        var mainPanel = document.getElementById('sidenav-main');
        mainPanel.classList.remove(classSidenavPanelSubopened);
        mainPanel.scrollTop = 0;
        mainPanel.classList.remove(classSidenavPanelHidden);
        var otherPanels = document.querySelectorAll(selectorSidenavPanel);
        Array.prototype.slice.call(otherPanels).forEach(function (panel) {
          if (panel === mainPanel) {
            return; 
          }
          panel.scrollTop = 0;
          panel.classList.add(classSidenavPanelHidden);
          panel.classList.remove(classSidenavPanelOpened);
          panel.classList.remove(classSidenavPanelSubopened);
        });
      }
    }

  })();

  //
  // CHOOSE REGION
  //  
  var chooseRegion = (function () {

    var selectorHeaderMainCountryIcon = '.wb-hdr19-main__right__link__countryicon',
        selectorHeaderMainTransparentCountryIcon = '.wb-hdr19-main__top__link__countryicon',
        selectorHeaderSidenavCountryIcon = '.wb-header__sidenav__main__countryicon',
        selectorHeaderMainCountryIconTitle = '.wb-hdr19-main__right__link__countryicon-title';

    function setCountryTitle (selector, text) {
      var title = document.querySelector(selector);
      if(!title) {
        return;
      }
      title.innerText = text;
    }

    function setCountryIcon (selector, src) {
      var icon = document.querySelector(selector);
      if (!icon) {
        return;
      }
      icon.dataset.src = src;
      icon.src = src;
      icon.style.opacity = 1;
    }

    return {
      setCountryIcon: function (src, text) {
        setCountryIcon(selectorHeaderMainCountryIcon, src);
        setCountryIcon(selectorHeaderMainTransparentCountryIcon, src);
        setCountryIcon(selectorHeaderSidenavCountryIcon, src);
        setCountryTitle(selectorHeaderMainCountryIconTitle, text);
      }, 
    }

  })();

  //
  // CART BADGE
  // 
  var cartBadge = (function () {
    var badge = document.getElementById('header-cart-badge'),
        badgeText = document.getElementById('header-cart-badge-text'),
        badgeCheck = document.getElementById('header-cart-badge-check'),
        classBadgeVisible = 'wb-hdr19-top__cart-badge--visible',
        classBadgeCheckVisible = 'wb-hdr19-top__cart-badge__check--visible',
        classBadgeCheckMovingFast = 'wb-hdr19-top__cart-badge__check--movingfast',
        classBadgeCheckMovingSlow = 'wb-hdr19-top__cart-badge__check--movingslow';

    var timer;

    function resetTimeout() {
      if (timer) {
        clearTimeout(timer);
      }
    }

    function updateText (count) {
      badgeText.innerText = count;
      if (parseInt(count) > 0 && !badge.classList.contains(classBadgeVisible)) {
        badge.classList.add(classBadgeVisible);
      }
    }

    function loadCount () {
      return axios.get('/cart.json', { headers: { 'Cache-Control': 'no-cache, no-store', 'Pragma': 'no-cache', 'Expires': 0 } }).then(function (response) {
        var itemCount = response.data.item_count || 0;
        var totalPrice = response.data.total_price || 0;
        updateText(itemCount);
        return { 
          itemCount: itemCount,
          totalPrice: totalPrice,
          items: response.data.items
        };
      });
    }

    function showCheck (targetElement, onFinish, quickadd) {
      resetTimeout();
      badgeCheck.classList.remove(classBadgeCheckVisible);
      badgeCheck.classList.remove(classBadgeCheckMovingFast);
      badgeCheck.classList.remove(classBadgeCheckMovingSlow);
      badgeCheck.style.top = '';
      badgeCheck.style.right = '';

      if (typeof targetElement.get !== 'undefined') {
        targetElement = targetElement.get(0);
      }
      var badgeCheckRect = badgeCheck.getBoundingClientRect();
      var targetRect = targetElement.getBoundingClientRect();
      var width = window.innerWidth;
      var positionTop = Math.round(targetRect.top + targetRect.height/2 - badgeCheckRect.height/2 - badgeCheckRect.top + parseInt(window.getComputedStyle(badgeCheck).getPropertyValue('top')));
      var badgeRightTmp = parseInt(window.getComputedStyle(badgeCheck).getPropertyValue('right'));
      var positionRight1 = Math.round(width - targetRect.left - targetRect.width - (width - badgeCheckRect.left) + badgeCheckRect.width/2 + badgeRightTmp);
      var positionRight2 = Math.round(positionRight1 + targetRect.width/2);

      badgeCheck.style.top = parseInt(positionTop) + 'px';
      badgeCheck.style.right = parseInt(!!quickadd ? positionRight2 : positionRight1) + 'px';
      timer = setTimeout(function () {
        badgeCheck.classList.add(classBadgeCheckVisible);
        badgeCheck.classList.add(classBadgeCheckMovingFast);
        setTimeout(function() {
          badgeCheck.style.right = parseInt(positionRight2) + 'px';
        }, 0);
        timer = setTimeout(function () {
          badgeCheck.classList.add(classBadgeCheckMovingSlow);
          badgeCheck.classList.remove(classBadgeCheckMovingFast);
          setTimeout(function () {
            badgeCheck.style.top = '';
            badgeCheck.style.right = '';
          }, 0);
          timer = setTimeout(function () {
            loadCount().then(function () {
              badgeCheck.classList.remove(classBadgeCheckVisible);
              badgeCheck.classList.remove(classBadgeCheckMovingSlow);
              if (typeof onFinish === 'function') {
                onFinish();
              }
            });
          }, 750);
        }, 250);
      }, 300);
    }

    return {
      showCheck: showCheck,
      loadCount: loadCount
    };

  })();

  //
  // FLYOUT
  //
  var mainFlyoutMenu = (function () {

    // var backdrop = document.getElementById('wb-bckdrp19-flyout');
    // var classBackdropShow = 'wb-bckdrp19--show';

    var selectorMainLink = 'a.wb-hdr19-main__left__link',
        selectorFlyoutLink = 'a.wb-hdr19-main__flyout__left__link',
        selectorFlyoutGroup = '.wb-hdr19-main__flyout__right',
        classFlyout = 'wb-hdr19-main__flyout',
        classMainLinkActive = 'wb-hdr19-main__left__link--active',
        classFlyoutActive = 'wb-hdr19-main__flyout--active',
        classFlyoutLinkActive = 'wb-hdr19-main__flyout__left__link--active',
        classFlyoutGroupActive = 'wb-hdr19-main__flyout__right--active',    
        mouseOutDelay = 250;

    var mainLeftLinks,
        mouseOutTimer;

    function getFlyoutForLeftLink (element) {
      return element.dataset.href && element.dataset.href.substr(0, 1) === '#' && document.getElementById(element.dataset.href.substr(1));
    }

    function isFlyoutForLeftLink (flyout) {
      return flyout && flyout.classList.contains(classFlyout);
    }

    function getFlyoutLeftLinks (flyout) {
      return Array.prototype.slice.call(flyout.querySelectorAll(selectorFlyoutLink)); 
    }

    function getFlyoutRightGroups (flyout) {
      return Array.prototype.slice.call(flyout.querySelectorAll(selectorFlyoutGroup));
    }

    function resetMainTimeout () {
      if (mouseOutTimer) { 
        clearTimeout(mouseOutTimer);
      }
    }

    function setMainLeftActive (element) {
      var flyout = getFlyoutForLeftLink(element);
      if (!isFlyoutForLeftLink(flyout)) {
        return;
      }

      element.classList.add(classMainLinkActive);
      flyout.classList.add(classFlyoutActive);
    }

    function removeMainLeftActive () {
      mainLeftLinks.forEach(function (e) { 
        var flyout = getFlyoutForLeftLink(e);
        if (!isFlyoutForLeftLink(flyout)) {
          return;
        }
        e.classList.remove(classMainLinkActive);
        flyout.classList.remove(classFlyoutActive);
      });
    }

    function setFlyoutLeftActive (flyoutRightGroups, element) {
      var href = element.dataset.href || element.getAttribute('href');
      flyoutRightGroups.forEach(function (e) {
        if (e.hasAttribute('id')) {
          if (e.id === href.substr(1)) {
            e.classList.add(classFlyoutGroupActive);
          } else if (e.classList.contains(classFlyoutGroupActive)) {
            e.classList.remove(classFlyoutGroupActive);
          }
        }
      });
      if (href.substr(0, 1) === '#') {
        element.classList.add(classFlyoutLinkActive);
      }
    }

    function removeFlyoutLeftActive (flyoutLeftLinks, except) {
      flyoutLeftLinks.forEach(function (e) {
        if (e !== except && e.classList.contains(classFlyoutLinkActive)) { 
          e.classList.remove(classFlyoutLinkActive); 
        }
      });
    }

    // TODO: use one flyout and toggle children visibility

    function onMainLeftLinkMouseEnter (element) {
      resetMainTimeout();
      removeMainLeftActive();
      setMainLeftActive(element);
      // backdrop.classList.add(classBackdropShow);
    }

    function onMainLeftLinkMouseLeave (flyoutLeftLinks, flyoutRightGroups) {
      resetMainTimeout();
      mouseOutTimer = setTimeout(function () {
        resetMainTimeout();
        removeMainLeftActive();
        if (flyoutRightGroups && flyoutLeftLinks && flyoutLeftLinks[0]) {
          removeFlyoutLeftActive(flyoutLeftLinks, null);
          setFlyoutLeftActive(flyoutRightGroups, flyoutLeftLinks[0]);
        }
        // backdrop.classList.remove(classBackdropShow);
      }, mouseOutDelay);
    }


    document.addEventListener('DOMContentLoaded', function () {
      mainLeftLinks = Array.prototype.slice.call(document.querySelectorAll(selectorMainLink));
      mainLeftLinks.forEach(function (element) {
        element.addEventListener('mouseenter', onMainLeftLinkMouseEnter.bind(null, element), { passive: true });
        element.addEventListener('mouseleave', onMainLeftLinkMouseLeave, { passive: true });
        element.addEventListener('click', function (event) {
          if (isMobile()) {
            event.preventDefault();
            return;
          }
        });

        var flyout = getFlyoutForLeftLink(element);
        if (!isFlyoutForLeftLink(flyout)) {
          return;
        }

        var flyoutLeftLinks = getFlyoutLeftLinks(flyout);
        var flyoutRightGroups = getFlyoutRightGroups(flyout);

        flyout.addEventListener('mouseenter', resetMainTimeout, { passive: true });
        flyout.addEventListener('mouseleave', onMainLeftLinkMouseLeave.bind(null, flyoutLeftLinks, flyoutRightGroups), { passive: true });

        flyoutLeftLinks.forEach(function (element) {
          element.addEventListener('mouseenter', function () {
            resetMainTimeout();
            removeFlyoutLeftActive(flyoutLeftLinks, element);
            setFlyoutLeftActive(flyoutRightGroups, element);
          }, { passive: true });
          if (!element.dataset.href) {
            element.addEventListener('click', function (event) {
              event.preventDefault();
            });
          }
        });
      });
    }, { passive: true });

    return {};
  })();



  //
  // BLOG
  //
  document.addEventListener('DOMContentLoaded', function () {
    if (document.body.classList.contains('wb-blog')) {
      var selectorMainLink = '.wb-hdr19-main__left__link',
          classMainLinkActive = 'wb-hdr19-main__left__link--active',
          mouseOutDelay = 250;

      var mainLeftLinks,
          activeLeftLink,
          mouseOutTimer;

      mainLeftLinks = Array.prototype.slice.call(document.querySelectorAll(selectorMainLink));

      activeLeftLink = mainLeftLinks.filter(function (element) {
        return element.classList.contains(classMainLinkActive);
      })[0];

      function resetMainTimeout () {
        if (mouseOutTimer) { 
          clearTimeout(mouseOutTimer);
        }
      }

      function onMainLeftLinkMouseEnter (element) {
        resetMainTimeout();
        mainLeftLinks.forEach(function (e) {
          if (e !== element && e.classList.contains(classMainLinkActive)) { 
            e.classList.remove(classMainLinkActive); 
          }
        });
        element.classList.add(classMainLinkActive);
      }

      function onMainLeftLinkMouseLeave () {
        resetMainTimeout();
        mouseOutTimer = setTimeout(function () {
          resetMainTimeout();
          mainLeftLinks.forEach(function (e) {
            if (e.classList.contains(classMainLinkActive)) { 
              e.classList.remove(classMainLinkActive); 
            }
          });
          if (typeof activeLeftLink !== 'undefined') {
            activeLeftLink.classList.add(classMainLinkActive);
          }
        }, mouseOutDelay);
      }

      mainLeftLinks.forEach(function (element) {
        element.addEventListener('mouseenter', onMainLeftLinkMouseEnter.bind(null, element), { passive: true });
        element.addEventListener('mouseleave', onMainLeftLinkMouseLeave, { passive: true });
      });
    }
  }, { passive: true });

  //
  // LOCALE CHANGER MIDDLE EAST
  //
  if (document.location.hostname == 'me.womensbest.com' || document.documentElement.classList.contains('wb-me')) {
    document.addEventListener('DOMContentLoaded', function () {
      (function () {
        var domain = window.location.hostname.replace(/^[^.]+/g, '');	

        function resetLang() {
          Cookies.remove('wb_shop_lang_pref', {path: '/', domain: domain});
        }

        function getLang() {
          return Cookies.get('wb_shop_lang_pref');
        }

        function setLang(lang) {
          Cookies.set('wb_shop_lang_pref', lang, {expires: 0.25, path: '/', domain: domain});
        }

        function countryCodeToLocale(countryCode) {
          switch (countryCode) {
            case 'AE':
              if (window.navigator.language && /^ar\b/.test(window.navigator.language)) {
                return 'ar';
              }
              return 'en';
            default:
              return 'ar';
          }
        }

        function changeLocale(lang) {
          var path,
              localeForm = $('#localization_form'),
              localeFormReturn = $('#localization_form input[name="return_to"]');

          if($('[data-locale="'+lang+'"]').hasClass('wb-hdr19-main__right__locale-active')){
            return;
          }

          if(location.pathname.indexOf('/apps/') != -1){
            return;
          }



          if (lang === 'en') {
            path = '/'+lang+document.location.pathname;
            localeForm.attr('action','/'+lang+'/localization');
            localeFormReturn.attr('value',path);
            localeForm.submit();
          } else {
            path = document.location.pathname.replace(/^\/[a-z]{2}($|\/)/, '/')
            localeForm.attr('action','/localization');
            localeFormReturn.attr('value',path);
            localeForm.submit();
          }

        }

        $('.wb-locale_change').click(function(){
          if($(this).hasClass('wb-hdr19-main__right__locale-active')){
            return;
          }

          var locale = $(this).attr('data-locale');

          if(locale === 'en'){
            setLang(locale);
            changeLocale(locale);
          } else {
            setLang('ar');
            changeLocale('ar');
          }

        });

        if(getLang()){
          changeLocale(getLang());
        } else {
          var interval = setInterval(function(){
            var ipCache = GeoRedirect.getIpShopCache();
            if (ipCache && ipCache.country_code) {
              var locale = countryCodeToLocale(ipCache.country_code)
              setLang(locale);
              changeLocale(locale);
              clearInterval(interval);
              return;
            }
          }, 500);
        }
      })();

      function updateCurrency(currency) {
        var cookieCurrency = DoublyGlobalCurrency.cookie.read();
        var newCurrency = currency || cookieCurrency;
        if(cookieCurrency == 'USD'){
          jQueryGrizzly('[name=doubly-currencies]').val(newCurrency);
          jQueryGrizzly('.doubly-wrapper .currency-switcher, .doubly-float .currency-switcher').niceSelect();
          jQueryGrizzly('.doubly-wrapper').attr('data-nosnippet', '');
          jQueryGrizzly('.doubly-wrapper .currency-switcher .option[data-value="'+newCurrency+'"]').addClass('selected');
          DoublyGlobalCurrency.convertAll(newCurrency);
        }
      }

      var doublyGlobalReadyInterval = setInterval(function(){
        if (typeof DoublyGlobalCurrency !== 'undefined') {
          switch (GeoRedirect.getIpShopCache().country_code){
            case 'AE':
              updateCurrency('AED');
              break;
            case 'SA':
              updateCurrency('SAR');
              break;
            case 'BH':
              updateCurrency('BHD');
              break;
            case 'KW':
              updateCurrency('KWD');
              break;
            case 'OM':
              updateCurrency('OMR');
              break;
            case 'QA':
              updateCurrency('QAR');
              break;
            case 'DZ':
              updateCurrency('DZD');
              break;
            case 'JO':
              updateCurrency('JOD');
              break;
            case 'SD':
              updateCurrency('SDG');
              break;
            case 'MA':
              updateCurrency('MAD');
              break;
            case 'TN':
              updateCurrency('TND');
              break;
            case 'LB':
              updateCurrency('LBP');
              break;
            default:
              break;
          }
          clearInterval(doublyGlobalReadyInterval);
        }
      },500);

    }, { passive: true });
  }

  //
  // TRANSPARENCY
  //
  var transparency = (function () {
    var elContentOffset,
        classTransparent = 'wb-hdr19--transparent',
        selectorBottom = '.wb-hdr19-bottom',
        initialized = false,
        y = 0,
        o = 150;

    function hasClass() {
      return header.classList.contains(classTransparent);
    }

    function handleResize() {
      if (elContentOffset) {
        o = elContentOffset.offsetTop + 100 - header.offsetHeight;
      }
    }

    function handleBottom() {
      var has = hasClass();
      document.querySelectorAll(selectorBottom).forEach(function (element) {
        if (has) {
          element.style.display = 'none';
        } else {
          element.style.display = '';
        }
      });
    }

    function handleScroll() {
      y = window.scrollY || window.pageYOffset;
      if (y >= o) {
        if (hasClass()) {
          header.classList.remove(classTransparent);
        }
      } else {
        if (!hasClass()) {
          header.classList.add(classTransparent);
        }
      }
      handleBottom()
    }

    function init() {

    }

    function enable(element) {
      if (element) {
        elContentOffset = element;
      }
      handleResize();
      handleScroll(); 
      if (initialized) {
        return; 
      }
      initialized = true;
      window.addEventListener('resize', throttle(50, handleResize), { passive: true });
      window.addEventListener('scroll', throttle(50, handleScroll), { passive: true });
    }

    return {
      enable: enable
    };
  })();

  //
  // RECHARGE FIX
  //
  document.addEventListener('DOMContentLoaded', function () {
    if (window.location.pathname.indexOf('/tools/recurring') !== -1) {
      var ids = ['#header-sidenav', '#wb-hdr19-banner', '#wb-hdr19'],
          selector = ids.map(function(id) { return id + ' [href*="/tools/recurring"]'; }).join(', ');
      Array.prototype.slice.call(document.querySelectorAll(selector)).forEach(function(el) {
        el.href = el.href.replace(/.*#/, '#').replace(/&.*/, '');
      });
    }
  }, { passive: true });

  return {
    setCountryIcon: chooseRegion.setCountryIcon,
    showCartCheck: cartBadge.showCheck,
    loadCartCount: cartBadge.loadCount,
    enableTransparency: transparency.enable,
    default_nav: default_nav/*,
    sidenav: sidenav,
    default_nav: default_nav*/
  };

})();